import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class CustomerNameValidatorService {
  public CustomerNameValidator() {
    return (control: AbstractControl): ValidationErrors | null => {
      const firstName = control.get('firstName')?.value;
      const lastName = control.get('lastName')?.value;
      const companyName = control.get('companyName')?.value;

      if (!firstName && !lastName && !companyName) {
        return { invalidCustomerName: true};
      }
      
      return null;
    };
  }
}
  